module.exports = __webpack_public_path__ + "img/nationalNumber.0908c403.svg";